import React, { useState } from 'react';
import PropTypes from "prop-types";

import { Redirect } from "react-router-dom";

import { Auth } from 'aws-amplify';

import { MuiThemeProvider, createMuiTheme, withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

//import purple from "@material-ui/core/colors/purple";

import Brand from "./Brand";

const theme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      main: "#8822c2"
    },
    secondary: {
      main: "#7ed4ab"
    }
  },
  typography: {
    useNextVariants: true
  }
});

const styles = theme => ({
  root: {
  },
  panel: {
    marginTop: 120,
    marginLeft: "auto",
    marginRight: "auto",
    width: "30%",
    minWidth: 360,
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  }
});


function SignIn(props) {

  //console.log("sign in");

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [failed, setFailed] = useState(false);

  const { onChallenge } = props;

  async function signIn() {
    //console.log("handle sign in");
    try {
      const user = await Auth.signIn(username, password);
      //console.log(user);
      setUsername("");
      setPassword("");
      setFailed(false);
      onChallenge(user);
    }
    catch(err) {
      console.log(err);
      setUsername("");
      setPassword("");
      setFailed(true);
    }
  }

  return (
    <React.Fragment>
      {failed &&
      <div>
        <Typography variant="body1" color="error" gutterBottom >
          Sign in failed. Please verify you are using the correct username and password.
        </Typography>
      </div>
      }
      <div style={{paddingBottom: 48}} >
        <TextField fullWidth
          label="User Name"
          value={username}
          InputProps={{type: "text", name: "username"}}
          onChange={(event) => { setUsername(event.target.value); }}
        />
      </div>
      <div style={{paddingBottom: 48}} >
        <TextField fullWidth
          label="Password"
          value={password}
          autoComplete="off"
          InputProps={{type: "password", name: "password"}}
          onChange={(event) => { setPassword(event.target.value); }}
        />
      </div>
      <div>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={signIn}
        >
          Sign in
        </Button>
      </div>
    </React.Fragment>
  );
}

function ConfirmSignIn(props) {

  const [code, setCode] = useState("");
  const [failed, setFailed] = useState(false);

  const { user, onConfirm } = props;

  async function confirmSignIn() {
    //console.log("handle confirm sign in");
    try {
      const confirmedUser = await Auth.confirmSignIn(user, code, user.ChallengeName);
      //console.log(confirmedUser);
      setCode("");
      setFailed(false);
      onConfirm(confirmedUser);
    }
    catch(e) {
      console.log("confirm sign in error");
      console.log(e);
      setCode("");
      setFailed(true);
    }
  }

  return (
    <React.Fragment>
      <div>
        <Typography variant="body1" gutterBottom >
          Enter the code sent to {user.challengeParam.CODE_DELIVERY_DESTINATION}.
        </Typography>
      </div>
      <div style={{paddingBottom: 48}} >
        <TextField fullWidth
          label="Code"
          value={code}
          error={failed ? true : undefined}
          helperText={failed ? "Invalid code entered" : undefined}
          autoComplete="off"
          InputProps={{type: "text", name: "code"}}
          onChange={(event) => { setCode(event.target.value); }}
        />
      </div>
      <div>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={confirmSignIn}
        >
          Submit
        </Button>
      </div>
    </React.Fragment>
  );
}

function CompleteNewPassword(props) {

  const [password, setPassword] = useState("");
  const [failed, setFailed] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const { user, onChallenge } = props;

  async function newPassword() {
    //console.log("handle new password");
    try {
      const updatedUser = await Auth.completeNewPassword(user, password);
      //console.log(updatedUser);
      setPassword("");
      setFailed(false);
      onChallenge(updatedUser);
    }
    catch(e) {
      console.log("new password error");
      console.log(e);
      setPassword("");
      setErrorMsg(e.message);
      setFailed(true);
    }
  }

  return (
    <React.Fragment>
      <div>
        <Typography variant="body1" gutterBottom >
          Update password.
        </Typography>
      </div>
      <div style={{paddingBottom: 48}} >
        <TextField fullWidth
          label="New Password"
          value={password}
          autoComplete="off"
          error={failed ? true : undefined}
          helperText={failed ? errorMsg : undefined}
          InputProps={{type: "password", name: "password"}}
          onChange={(event) => { setPassword(event.target.value); }}
        />
      </div>
      <div>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={newPassword}
        >
          Update
        </Button>
      </div>
    </React.Fragment>
  );
}

function Login(props) {

  const [flow, setFlow] = useState("signIn");
  const [user, setUser] = useState(null);

  const { classes } = props;

  //console.log("login");
  //console.log(props);

  function handleChallenge(user) {
    switch (user.challengeName) {
      case "SMS_MFA":
        setUser(user);
        setFlow("confirmSignIn");
        break;
      case "NEW_PASSWORD_REQUIRED":
        setUser(user);
        setFlow("completeNewPassword");
        break;
      default:
        console.log("default", user.challengeName);
    }
  }

  function handleConfirm(user) {
    //console.log("handleConfirm");
    setFlow("signedIn");
  }

  var flowComponent;

  switch (flow) {
    case "signIn":
      flowComponent = <SignIn onChallenge={handleChallenge} />;
      break;
    case "confirmSignIn":
      flowComponent = <ConfirmSignIn user={user} onConfirm={handleConfirm} />;
      break;
    case "completeNewPassword":
      flowComponent = <CompleteNewPassword user={user} onChallenge={handleChallenge} />;
      break;
    case "signedIn":
      return <Redirect to="/" strict={true} exact={true} />;
    default:
      flowComponent = null;
  }

  if (!flowComponent) {
    return null;
  }

  return (
    <MuiThemeProvider theme={theme}>
      <div>
        <Paper className={classes.panel}>
          <Brand />
          <div style={{ height: 24 }} />
          {flowComponent}
        </Paper>
      </div>
    </MuiThemeProvider>
  );
}

SignIn.propTypes = {
  onChallenge: PropTypes.func.isRequired
};

ConfirmSignIn.propTypes = {
  user: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired
};

Login.propTypes = {
  history: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Login);
